import { defineMessages } from 'react-intl-next';

export const i18n: {
    positionFilterEmploymentTypeLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    positionFilterEmploymentTypePlaceholder: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    positionFilterEmploymentTypeLabelSelected: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    positionFilterEmploymentTypeLabelUnselected: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	positionFilterEmploymentTypeLabel: {
		id: 'search-page.filters.names.positionEmploymentType',
		defaultMessage: 'Employment type',
		description: 'Label for filtering by employment type',
	},
	positionFilterEmploymentTypePlaceholder: {
		id: 'search-page.talent.filter.position-employment-type.content.placeholder',
		defaultMessage: 'Find employment types',
		description: 'Placeholder for employment type filter search input',
	},
	positionFilterEmploymentTypeLabelSelected: {
		id: 'search-page.talent.filter.position-employment-type.content.selected',
		defaultMessage: 'Selected',
		description: 'Employment type filter content selected',
	},
	positionFilterEmploymentTypeLabelUnselected: {
		id: 'search-page.talent.filter.position-employment-type.content.unselected',
		defaultMessage: 'Suggested',
		description: 'Employment type filter content unselected',
	},
});
